import angular from 'angular';
import uiRouter from 'angular-ui-router';
import auditsbymonthComponent from './auditsbymonth.component';

let auditsbymonthModule = angular.module('auditsbymonth', [
  uiRouter
])

.component('auditsbymonth', auditsbymonthComponent);

export default auditsbymonthModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditsbymonth/auditsbymonth.js